import React from "react";
import {
  Box,
  Text,
  Center,
  Link
  } from '@chakra-ui/react'
import styled from '@emotion/styled';

const Icon = styled(Box)`
display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
    cursor: pointer;
    > p {
        color: #70A37F;
    }
    > div > svg {
        fill: #70A37F;
    }

    &:hover {
        > p {
            color: #40634A;
        }
        > div > svg {
            fill: #40634A;
        }
    }
`

const Weather = (props) => {
  return (
    <Icon as={Link} href="https://forecast.weather.gov/MapClick.php?zoneid=IDZ065" target="_blank" rel="noopener noreferrer" _hover={{textDecoration: 'none'}}>
      <Center w="40%" mx="auto">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 51.46 45.738" {...props}>
        <path id="temperature-frigid-solid" d="M48.542,24.879V10.005a10.005,10.005,0,1,0-20.01,0V24.879a12.864,12.864,0,1,0,20.01,0ZM38.537,40.02a7.135,7.135,0,0,1-4.288-12.846V10.005a4.288,4.288,0,0,1,8.576,0v17.17A7.135,7.135,0,0,1,38.537,40.02ZM23.914,27.282a15.812,15.812,0,0,1,1.76-3.35v-.643L20.01,20.01l5.664-3.27V11.729l-7.861,4.538V11.184L21.4,7.593a1.073,1.073,0,0,0,0-1.519l-.759-.759a1.073,1.073,0,0,0-1.519,0L17.812,6.637V3.931A1.075,1.075,0,0,0,16.74,2.859H14.6a1.075,1.075,0,0,0-1.072,1.072V6.637L12.2,5.315a1.073,1.073,0,0,0-1.519,0l-.759.759a1.073,1.073,0,0,0,0,1.519l3.591,3.591v5.083l-4.493-2.6L7.682,8.692a1.087,1.087,0,0,0-1.331-.768L5.306,8.21a1.087,1.087,0,0,0-.768,1.331l.491,1.822L2.653,10a1.083,1.083,0,0,0-1.483.393L.089,12.265a1.083,1.083,0,0,0,.393,1.483l2.376,1.367-1.822.491a1.087,1.087,0,0,0-.768,1.331l.277,1.045a1.087,1.087,0,0,0,1.331.768L6.851,17.42l4.484,2.591L6.851,22.6l-4.976-1.34a1.091,1.091,0,0,0-1.331.768L.268,23.074a1.091,1.091,0,0,0,.768,1.331l1.822.491L.491,26.272A1.083,1.083,0,0,0,.1,27.755l1.081,1.876a1.083,1.083,0,0,0,1.483.393l2.376-1.367L4.547,30.48a1.091,1.091,0,0,0,.768,1.331l1.045.277a1.091,1.091,0,0,0,1.331-.768l1.331-4.967,4.5-2.6v5.083L9.933,32.427a1.073,1.073,0,0,0,0,1.519l.759.759a1.073,1.073,0,0,0,1.519,0l1.322-1.322V36.09a1.075,1.075,0,0,0,1.072,1.072h2.144a1.075,1.075,0,0,0,1.072-1.072V33.383l1.322,1.322a1.073,1.073,0,0,0,1.519,0l.759-.759a1.073,1.073,0,0,0,0-1.519l-3.609-3.591V23.753Zm16.053,1.563V27.157a1.429,1.429,0,1,0-2.859,0v1.688a4.288,4.288,0,1,0,2.859,0Z" transform="translate(0.059)" />
      </svg>
   </Center>
   <Text textAlign="center" fontSize={{base: 'xs', md: 'sm'}}>
        Weather
    </Text>
   </Icon>
  );
};

export default Weather;